import React, { Component } from 'react'
import { bindStateToProps, bindActionCreators } from 'lib'
import { connect } from 'react-redux'
import autoBind from 'auto-bind'
import uniqid from 'uniqid'

import Typography from '@material-ui/core/Typography'

import { saveActionLog } from 'lib/requestLog'
import { actions as helpActions } from 'store/modules/help'
import { actions as confirmActions } from 'store/modules/confirm'
import { isEmptyString } from 'lib/detectType'

import Help from 'components/molecules/Help'

class HelpContainer extends Component {
  constructor(props) {
    super(props)
    autoBind(this)
    this.helpKey = isEmptyString(this.props.helpKey)
      ? uniqid()
      : this.props.helpKey
  }

  componentDidMount() {}

  shouldComponentUpdate(nextProps) {
    const { confirmData = {} } = this.props
    const { confirmData: nextConfirmData = {} } = nextProps
    const { open } = confirmData[this.helpKey + '_help'] || {}
    const { open: nextOpen } = nextConfirmData[this.helpKey + '_help'] || {}
    return open !== nextOpen
  }

  async onClickIconButton(e) {
    e.stopPropagation()
    const {
      ConfirmActions,
      description: data = {},
      title: propTitle = '',
      message = ''
    } = this.props
    const { title, description } = data[this.helpKey] || {}
    saveActionLog({
      actionName: 'HelpContainer|' + this.helpKey,
      event: {},
      data: {}
    })
    ConfirmActions.show({
      title: title || propTitle,
      popupMessage: true,
      message: <Typography variant="body2">{description || message}</Typography>
    })
  }

  render() {
    const { description = {} } = this.props
    return (
      <React.Fragment>
        <Help
          {...this.props}
          {...this.state}
          proxy={this}
          description={description[this.helpKey]}
        />
      </React.Fragment>
    )
  }
}

export default connect(
  bindStateToProps({
    help: true
  }),
  bindActionCreators({
    helpActions,
    confirmActions
  })
)(HelpContainer)
